module.exports = __webpack_public_path__ + "static/media/gcdef_10048.07d5b143.ico";